import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './ui/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  msgs: any[];
  title = 'BTV-SyBi Admin';
  loading = false;
  resetMenu = false;

  watermark = environment.watermark.toString();

  constructor(private router: Router, private spinnerService: SpinnerService,
  ) {
    this.router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  ngOnInit() {
    this.spinnerService.connect().subscribe((state) => this.loading = state);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      Array.from(document.querySelectorAll('.watermarked')).forEach(function (el: Element) {
        if (el instanceof HTMLElement) {
          el.dataset.watermark = (' ' + el.dataset.watermark + ' ').repeat(555);
        }
      });
    }, 50);
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }
}
